const pad = (value: number) => String(value).padStart(2, '0')

const localDay = (date: Date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

/** Preset periode → `from`/`to` (`YYYY-MM-DD`, hari lokal, inklusif). */
export function periodRange(period: string, now = new Date()): { from?: string; to?: string } {
  if (period === 'today') return { from: localDay(now), to: localDay(now) }
  const days = period === '7d' ? 7 : period === '30d' ? 30 : 0
  if (!days) return {}
  const start = new Date(now)
  start.setDate(start.getDate() - (days - 1))
  return { from: localDay(start), to: localDay(now) }
}

/** `2026-10-19T09:00:00Z` → `19/10/2026 16:00` (zona waktu perangkat). */
export const dateTimeText = (iso?: string | null) => {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/** "baru saja", "5 mnt lalu", "3 jam lalu", "kemarin", "4 hari lalu", lalu tanggal. */
export function relativeTime(iso?: string | null, now = Date.now()): string {
  if (!iso) return '—'
  const time = new Date(iso).getTime()
  if (Number.isNaN(time)) return '—'
  const minutes = Math.max(Math.floor((now - time) / 60_000), 0)
  if (minutes < 1) return 'baru saja'
  if (minutes < 60) return `${minutes} mnt lalu`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} jam lalu`
  const days = Math.floor(hours / 24)
  if (days === 1) return 'kemarin'
  if (days < 7) return `${days} hari lalu`
  return dateTimeText(iso).slice(0, 10)
}

export const senderName = (sender?: { first_name?: string | null; last_name?: string | null } | null) =>
  [sender?.first_name, sender?.last_name].filter(Boolean).join(' ')
